import { IncidentModel } from './incident.model';
import { FraudDocumentModel } from './fraud-document.model';

export class FraudAamvaModel extends IncidentModel {
    public incidentFraudId = 0;
    public investigatorName: string;
    public investigatorPhoneNumber: string;
    public fraudDocuments: FraudDocumentModel[] = [];
    public cdlHolderIndicator = false;
    public commercialMotorVehicleIndicator = false;
    public hazardousMaterialIndicator = false;
    public passengerIndicator = false;
    public driverLicenseNumber: string;
    public driverLicenseJurisdictionId: number;
}
